import axios from 'axios'

import { env } from '@/app/env'
import { applyInterceptors } from './apply-interceptors'

export const apiMotor = (() => {
  const client = axios.create({ baseURL: env.motorBaseUrl })
  applyInterceptors(client)
  return client
})()
